import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconReply.tsx
const OutlinedFilledReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z" })
});
const OutlinedReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z" })
});
const RoundedFilledReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m275-477 113 113q13 14 13 33t-13 33q-14 14-34 14t-33-14L128-490q-14-14-14-34t14-34l194-193q14-14 33.5-14t33.5 14q13 14 13 33.5T389-685L275-571h375q92 0 154 62t62 153v134q0 20-14 33.5T818-175q-20 0-33.5-13.5T771-222v-134q0-54-33.5-87.5T650-477H275Z" })
});
const RoundedReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m275-477 113 113q13 14 13 33t-13 33q-14 14-34 14t-33-14L128-490q-14-14-14-34t14-34l194-193q14-14 33.5-14t33.5 14q13 14 13 33.5T389-685L275-571h375q92 0 154 62t62 153v134q0 20-14 33.5T818-175q-20 0-33.5-13.5T771-222v-134q0-54-33.5-87.5T650-477H275Z" })
});
const SharpFilledReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z" })
});
const SharpReply = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z" })
});
const componentMap = {
	outlined: OutlinedReply,
	"outlined-fill": OutlinedFilledReply,
	rounded: RoundedReply,
	"rounded-fill": RoundedFilledReply,
	sharp: SharpReply,
	"sharp-fill": SharpFilledReply
};
const IconReply = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconReply };